import React, { useState, useEffect } from 'react'
import { isBillingAvailable } from '../_helpers/billing'
import OpenStackServicesViewService from './OpenStackServicesViewService'

const OpenStackServicesView = (props) => {
  const { backendServices, billingServices, subscriptionServices, supportedServiceConfigs } = props

  const [expandedPanel, setExpandedPanel] = useState('')
  const [serviceNames, setServiceNames] = useState([])
  const [filteredServiceNames, setFilteredServiceNames] = useState([])

  const handleChangeExpandedPanel = (panel) => (event, newExpanded) => {
    setExpandedPanel(newExpanded ? panel : false)
  }

  useEffect(() => {
    let service_names = []

    if (backendServices.length > 0) {
      backendServices.forEach(item => {
        if (!service_names.includes(item.service)) {
          service_names.push(item.service)
        }
      })
    } else if (billingServices.length > 0) {
      billingServices.forEach(item => {
        if (!service_names.includes(item.service_name)) {
          service_names.push(item.service_name)
        }
      })
    } else {
      subscriptionServices.forEach(item => {
        if (!service_names.includes(item.service)) {
          service_names.push(item.service)
        }
      })
    }
    
    setServiceNames(service_names)
  }, [backendServices, billingServices, subscriptionServices])

  useEffect(() => {
    setFilteredServiceNames(serviceNames.filter(item => isBillingAvailable(item, supportedServiceConfigs)))
  }, [serviceNames, supportedServiceConfigs])
  
  return (
    <>
      {
        filteredServiceNames.map((item, index) => (
          <OpenStackServicesViewService
            key={index}
            serviceName={item}
            backendServices={backendServices}
            billingServices={billingServices}
            supportedServiceConfigs={supportedServiceConfigs}
            expandedPanel={expandedPanel}
            handleChangeExpandedPanel={handleChangeExpandedPanel}
          />
        ))
      }
    </>
  )
}

export default OpenStackServicesView